// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keyPane_cT3EW {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    overflow: auto;
  }
  
  .keyItemFlex_O0air {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    align-items: center;
    align-content: center;
    margin-bottom: 4px;
  }

  .keyItemFlexSplit_whssA {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    align-content: center;
    margin-bottom: 4px;
  }

  .keyItemFlexActive_ll68I {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    align-items: center;
    align-content: center;
    margin-bottom: 4px;
    margin-left : -10px;
  }

  .keyItemFlexSplitActive_HKPo5 {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    align-content: center;
    margin-bottom: 4px;
    margin-left : -10px;
  }
  
  
  .keyVerticalPane_kmMEq {
    justify-self: center;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    overflow: auto;
  }

  .keyHorizontalPane_wGqlG {
    justify-self: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    overflow: auto;
    padding-right: 16px;
  }
  
  .keyTitle_K5obD {
    margin-bottom: 8px;
    max-width: 150px;
  }

  .keyTitleCenter_URFtV {
    margin-bottom: 8px;
    align-self:center;
  }
  
  .keyItemText_cnHZb{
    padding: 0 8 0 8;
  }
  
  .keyValue_sF9NZ {
    padding-left: 16px;
    align-self: center;
  }
  
  .keyLabel_DUpEo {
    align-self: center;
  }

  .box_lzpgF {
    height: 20px;
    width: 20px;
    margin-right: 8px;
    border: 1px solid var(--color-base100);
    border-radius: 2px;
  }

  .activeBox_DEl7p {
    height: 20px;
    width: 20px;
    margin-right: 8px;
    border: 1px solid var(--color-base500);
    border-radius: 2px;
  }

  .keyVertical_nAJjN {
    display: flex;
    flex-direction: column;
  }

  .splitKeys_QY52b {
    justify-content: center;
    align-items: center;
    justify-items: center;
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes-graphs/lib/viewers/KeyRenderer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;;;EAGA;IACE,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;EACvB","sourcesContent":[".keyPane {\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    overflow: auto;\n  }\n  \n  .keyItemFlex {\n    display: flex;\n    justify-content: space-evenly;\n    flex-direction: row;\n    align-items: center;\n    align-content: center;\n    margin-bottom: 4px;\n  }\n\n  .keyItemFlexSplit {\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    align-items: center;\n    align-content: center;\n    margin-bottom: 4px;\n  }\n\n  .keyItemFlexActive {\n    display: flex;\n    justify-content: space-evenly;\n    flex-direction: row;\n    align-items: center;\n    align-content: center;\n    margin-bottom: 4px;\n    margin-left : -10px;\n  }\n\n  .keyItemFlexSplitActive {\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    align-items: center;\n    align-content: center;\n    margin-bottom: 4px;\n    margin-left : -10px;\n  }\n  \n  \n  .keyVerticalPane {\n    justify-self: center;\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    overflow: auto;\n  }\n\n  .keyHorizontalPane {\n    justify-self: center;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    overflow: auto;\n    padding-right: 16px;\n  }\n  \n  .keyTitle {\n    margin-bottom: 8px;\n    max-width: 150px;\n  }\n\n  .keyTitleCenter {\n    margin-bottom: 8px;\n    align-self:center;\n  }\n  \n  .keyItemText{\n    padding: 0 8 0 8;\n  }\n  \n  .keyValue {\n    padding-left: 16px;\n    align-self: center;\n  }\n  \n  .keyLabel {\n    align-self: center;\n  }\n\n  .box {\n    height: 20px;\n    width: 20px;\n    margin-right: 8px;\n    border: 1px solid var(--color-base100);\n    border-radius: 2px;\n  }\n\n  .activeBox {\n    height: 20px;\n    width: 20px;\n    margin-right: 8px;\n    border: 1px solid var(--color-base500);\n    border-radius: 2px;\n  }\n\n  .keyVertical {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .splitKeys {\n    justify-content: center;\n    align-items: center;\n    justify-items: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyPane": `keyPane_cT3EW`,
	"keyItemFlex": `keyItemFlex_O0air`,
	"keyItemFlexSplit": `keyItemFlexSplit_whssA`,
	"keyItemFlexActive": `keyItemFlexActive_ll68I`,
	"keyItemFlexSplitActive": `keyItemFlexSplitActive_HKPo5`,
	"keyVerticalPane": `keyVerticalPane_kmMEq`,
	"keyHorizontalPane": `keyHorizontalPane_wGqlG`,
	"keyTitle": `keyTitle_K5obD`,
	"keyTitleCenter": `keyTitleCenter_URFtV`,
	"keyItemText": `keyItemText_cnHZb`,
	"keyValue": `keyValue_sF9NZ`,
	"keyLabel": `keyLabel_DUpEo`,
	"box": `box_lzpgF`,
	"activeBox": `activeBox_DEl7p`,
	"keyVertical": `keyVertical_nAJjN`,
	"splitKeys": `splitKeys_QY52b`
};
export default ___CSS_LOADER_EXPORT___;
